export enum AppointmentTypeEnum {
  CONFERENCE = 'CONFERENCE',
  ONE_TO_ONE = 'ONE_TO_ONE',
  ON_SITE = 'ON_SITE',
}
